var isCallable = require('../internals/is-callable');

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/is-object.js